import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useCallback } from "react"
import {
	CouponProgramForm,
	type CouponProgramFormValues,
} from "@/components/coupons/coupon-program-form"
import { useCreateCouponProgram } from "@/queries/marketplace"

export const Route = createFileRoute("/coupons/programs/new")({
	component: CreateCouponProgramPage,
})

function CreateCouponProgramPage() {
	const navigate = useNavigate()
	const createMutation = useCreateCouponProgram()

	const handleSubmit = useCallback(
		async (values: CouponProgramFormValues) => {
			const result = await createMutation.mutateAsync({
				key: values.key,
				name: values.name,
				codePrefix: values.codePrefix || null,
				description: values.description,
				type: values.type,
				value: values.value,
				currencyAmounts: values.currencyAmounts,
				region: values.region,
				minimumOrderAmount: values.minimumOrderAmount,
				maximumDiscountAmount: values.maximumDiscountAmount,
				validityDays: values.validityDays,
				newBuyersOnly: values.newBuyersOnly,
				combinable: values.combinable,
			})
			navigate({
				to: "/coupons/programs/$programId",
				params: { programId: result.id },
			})
		},
		[createMutation, navigate],
	)

	return (
		<div className="p-6">
			<CouponProgramForm
				mode="create"
				onSubmit={handleSubmit}
				isSubmitting={createMutation.isPending}
			/>
		</div>
	)
}
